import React from 'react'
import Header from  "../../components/header/Header"
import Footer from  "../../components/footer/Footer"
import AboutMid from '../../components/about-mid/AboutMid'

export default function About()
{
    return(
        <div>
        <Header></Header>
        <AboutMid></AboutMid>
      <Footer></Footer>
        </div>
    )
}